import { z } from 'zod';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { requiredString } from '@/utils/zodUtils';

export const AddPricingSpecInLenderContextSchema = (t: GetTextIdTranslationType) =>
  z
    .object({
      lenderId: requiredString(t),
      pricingNameInLenderContext: requiredString(t),
      pricingVersion: requiredString(t),
    })
    .strict();

export type AddPricingSpecInLenderContextType = z.infer<ReturnType<typeof AddPricingSpecInLenderContextSchema>>;
